module.exports = __webpack_public_path__ + "img/search.553b2706.svg";